import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentExternalId,
  selectVulnDetail
} from 'store/Manage/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { updateVuln } from 'store/Manage/actions';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { Input } from 'Common/Components/StandardTextField/styled';
import ExpandableWrapper from '../ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import Wrapper from './styled';
import get from 'lodash/get';

const TAB = 'general';
const ID = 'externalID';

const ExternalId = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const externalId = useSelector(selectCurrentExternalId);
  const currentVuln = useSelector(selectVulnDetail);
  const vulnId = get(currentVuln, '_id', 0);
  const isExpanded = useExpandable(TAB, ID, externalId, vulnId);
  const readOnly = useSelector(selectIsReadOnly);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const disabled = readOnly || !canUpdate;

  const [localValue, setLocalValue] = useState(externalId || '');
  useEffect(() => {
    setLocalValue(externalId || '');
  }, [externalId]);

  const onBlur = (e) => {
    const newValue = e.target.value;
    if (newValue !== (externalId || '')) dispatch(updateVuln(currentVuln, 'external_id', newValue, true));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.externalID' }) } tab={ TAB } id={ ID }>
      <Wrapper>
        <Input
          value={ localValue }
          onChange={ (e) => setLocalValue(e.target.value) }
          onBlur={ onBlur }
          disabled={ disabled }
          name="external_id"
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default ExternalId;
